import { render } from "./CBadge.vue?vue&type=template&id=d0d199fe"
import script from "./CBadge.vue?vue&type=script&lang=js"
export * from "./CBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__